import {appApi} from "./api.service";

const endpointPrefix = 'worker/salary-transparency';

export interface SalaryTransparencyDocument {
    type: 'system_document' | 'client_document';
    id: number;
    name: string;
    original_name: string | null;
    mime_type: string | null;
    extension: string | null;
}

export interface PendingDocumentsResponse {
    documents: SalaryTransparencyDocument[];
    activeContractId: number | null;
}

const getPendingDocuments = async (): Promise<PendingDocumentsResponse> => {
    const response = await appApi.get(endpointPrefix + '/documents');
    return {
        documents: response.data?.data ?? [],
        activeContractId: response.data?.active_contract_id ?? null,
    };
};

const acceptDocuments = async (
    systemDocumentIds: number[],
    clientDocumentIds: number[]
): Promise<void> => {
    await appApi.post(endpointPrefix + '/accept', {
        system_document_ids: systemDocumentIds,
        client_document_ids: clientDocumentIds,
    });
};

const rejectDocuments = async (trigger: 'matching' | 'admin_match'): Promise<{ action: string }> => {
    const response = await appApi.post(endpointPrefix + '/reject', { trigger });
    return response.data;
};

const getDocumentBase64 = async (doc: SalaryTransparencyDocument): Promise<string> => {
    // Nie wymaga activeContractId — dokumenty są dopasowane po formie, dostępne jeszcze przed podpisaniem umowy.
    const endpoint = doc.type === 'client_document'
        ? `${endpointPrefix}/client-document/${doc.id}/base64-generate`
        : `${endpointPrefix}/system-document/${doc.id}/base64-generate`;
    const response = await appApi.get(endpoint);
    return response.data.data;
};

export {getPendingDocuments, acceptDocuments, rejectDocuments, getDocumentBase64};
